<template>
    <rkm-overlay>
        <rkm-container
            class="rkm-container"
            fluid
        >
            <rkm-row v-if="loaded">
                <rkm-col cols="12">
                    <Form class="mt-3" />
                </rkm-col>
            </rkm-row>
        </rkm-container>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/painel-senha/emissao-senha-externo/Form'

// Mixins.
import { error, repository } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

export default {
    components: { Form },
    computed: {
        params() {
            return this.$route.params
        },
    },
    created() {
        this.repositories = {
            autenticacao: this.getConectaSusRepository('administracao.autenticacao'),
            cliente: this.getConectaSusRepository('intranet.cliente'),
        }

        this.clear()
    },
    data: () => ({
        loaded: false,
    }),
    methods: {
        ...mapGetters(['getAutenticacao']),
        ...mapActions([
            'clear',
            'setAutenticacao',
            'setCentroCusto',
            'setCliente',
            'setCustomer',
            'setLoading',
            'setLotacao',
            'unsetLoading',
        ]),
        load() {
            this.setLoading()

            this.repositories.cliente.index({link: this.params.cliente})
                .then(({ data }) => {
                    this.setCustomer(data)
                    this.login()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        login() {
            this.setLoading()

            this.repositories.autenticacao.login({usuario: this.params.usuario, senha: this.params.senha})
                .then(({ data }) => {
                    this.setAutenticacao(data)
                    this.refresh()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        refresh() {
            this.setLoading()

            this.repositories.autenticacao.refresh({centro_custo_id: this.params.centroCustoId, lotacao_id: this.params.lotacaoId})
                .then(({ data }) => {
                    this.setAutenticacao(data)
                    this.setCentroCusto(data.centroCusto)
                    this.setCliente(data.cliente)
                    this.setLotacao(data.lotacao)

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [ error, repository ],
    mounted() {
        this.load()
    },
}
</script>

<style scoped>
.rkm-container {
    height: 100vh;
}
</style>